var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 py-2 position-relative bottom-0 footer-div"})
}
var staticRenderFns = []

export { render, staticRenderFns }